const date = new Date()
const classYear = (
  date.getFullYear() + (date.getMonth() >= 7 ? 1 : 0)
).toString()

export const defaults = {
  CATALOG_ID: 1,
  CLASS_YEAR: classYear,
  FIRST_NAME: 'First',
  PLAYER_NAME: 'Enter name',
  PLAYER_NUMBER: 23,
  SPORT: 'Sport'
}

export const printTechniques = {
  UNDEFINED: 'Undefined',
  VINYL: 'Vinyl',
  SCREEN: 'Screen',
  PRINTER: 'Printer',
  STICKER: 'Sticker',
  DTG: 'DTG',
  EMBROIDERY: 'Embroidery',
  APPLIQUE: 'Applique',
  NONE: 'None',
  DYESUB: 'DyeSub',
  WALL_ART: 'WallArt',
  DTGEPSON: 'DTGEpson'
}

export const printerMedia = {
  STRECH_PRINT_VP: 'StrechPrintVP',
  SOLUTIONS_OPAQUE: 'SolutionsOpaque',
  MAXIM: 'Maxim',
  ULTIMATE_DARK: 'UltimateDark',
  TURBO_PRINT: 'TurboPrint',
  HARDGOODS: 'Hardgoods',
  APPAREL: 'Apparel',
  BANNER: 'Banner',
  CANVAS: 'Canvas',
  POSTERS: 'Posters',
  WALL_GRAPHICS: 'WallGraphics',
  DIGI_MAG: 'DigiMag',
  BRUSHED_POLY_FLEECE: 'Brushed_Poly_Fleece',
  DTGEPSON: 'DTGEpson',
  PERFORMANCE_POLY: 'Performance_Poly'
}

export const sizeToAbbreviationMappings = {
  'Extra Small': 'XS',
  Small: 'S',
  Medium: 'M',
  Large: 'L',
  'Extra large': 'XL',
  '2 Extra large': '2XL',
  '3 Extra large': '3XL',
  '4 Extra large': '4XL',
  '5 Extra large': '5XL',
  'one size': 'ONE SIZE',
  'Large Tall': 'LT',
  'X-Large Tall': 'XLT',
  '2X-Large Tall': '2XLT',
  '3X-Large Tall': '3XLT',
  '4X-Large Tall': '4XLT'
}

export const colorLimitations = {
  SHOW_ALL: 0,
  SHOW_ONLY_LISTED: 1,
  EXCLUDE_LISTED: 2
}
